import { useEffect, useState } from 'react';
import { fetchPublicPackages } from '../services/publicPackages';
import { pricingPackages as fallbackPricingPackages } from '../components/pricing/pricingData';

export function usePublicPackages() {
  const [packages, setPackages] = useState(fallbackPricingPackages);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        const result = await fetchPublicPackages();
        if (!cancelled) {
          setPackages(result);
          setError(null);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to load packages');
          setPackages(fallbackPricingPackages);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { packages, loading, error };
}
